import { render, staticRenderFns } from "./backAddBid.vue?vue&type=template&id=edfca282&scoped=true"
import script from "./backAddBid.vue?vue&type=script&lang=js"
export * from "./backAddBid.vue?vue&type=script&lang=js"
import style0 from "./backAddBid.vue?vue&type=style&index=0&id=edfca282&prod&lang=less&scoped=true"
import style1 from "./backAddBid.vue?vue&type=style&index=1&id=edfca282&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfca282",
  null
  
)

export default component.exports